import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import {
  EmptyState,
  PagePaper,
  StatusChip,
} from 'dashboard/components/common';
import { fmtMoney } from 'utilities/format';

const STATUS_COLORS = {
  pending: 'warning',
  paid: 'primary',
  fulfilled: 'success',
  cancelled: 'error',
  refunded: 'secondary',
};

/** Last-N orders table on the Overview page. */
export default function RecentOrdersCard({ rows, loading, currency }) {
  return (
    <PagePaper sx={{ p: '18px', borderRadius: '16px' }}>
      <Typography fontWeight='700' mb='10px'>Recent orders</Typography>
      <TableContainer
        component={Box}
        sx={{
          border: '1px solid', borderColor: 'divider',
          borderRadius: '12px', overflowX: 'auto',
        }}
      >
        <Table size='small'>
          <TableHead sx={{ bgcolor: 'action.hover' }}>
            <TableRow>
              <TableCell>Order</TableCell>
              <TableCell>Customer</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading && (!rows || rows.length === 0) && (
              <TableRow>
                <TableCell colSpan={4}><EmptyState>No orders yet.</EmptyState></TableCell>
              </TableRow>
            )}
            {(rows || []).map((o) => (
              <TableRow key={o._id}>
                <TableCell>
                  <Typography fontWeight='600'>{o.number || String(o._id).slice(-6)}</Typography>
                  <Typography variant='caption' color='text.secondary'>
                    {o.placed_at ? new Date(o.placed_at).toLocaleString() : ''}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant='body2'>{o.customer_name || '—'}</Typography>
                  <Typography variant='caption' color='text.secondary'>{o.customer_email || ''}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant='body2'>{fmtMoney(o.grand_total, o.currency || currency)}</Typography>
                  <Typography variant='caption' color='text.secondary'>{o.item_count} items</Typography>
                </TableCell>
                <TableCell>
                  <StatusChip status={o.status} colors={STATUS_COLORS} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </PagePaper>
  );
}
